import api from "./api";
import { LoginResponse } from "../types/auth";

export const loginAPI = (username: string, password: string) => {
  return api.post<LoginResponse>(
    "/api/version_0/users/admin-login/",
    {
      username,
      password,
    }
  );
};

export const getUserDetails = () => {
  return api.get("/company/v1/get-user-details/");
};